// extracted by mini-css-extract-plugin
export default {"storyContainer":"Story_storyContainer__ZtAFE","mainTitle":"Story_mainTitle__49AYd","storyText":"Story_storyText__4fsDK","meImg":"Story_meImg__8nilI"};